export default {
    month: (new Date().getMonth() + 1).toString(),
    year: new Date().getFullYear()
};